export default __webpack_public_path__ + "static/media/dx_dance_hero.397afc85.png";